<div id="otp-root" class="login-new">
  <div class="onboarding-progress-container">
    <div class="onboarding-progress" id="otp-progress">
        <span id="progress-1" class="progress completed"></span>
        <span id="progress-2" class="progress active"></span>
        <span id="progress-3" class="progress"></span>
        <span id="progress-4" class="progress"></span>
        <span id="progress-5" class="progress"></span>
    </div>
    <p id="progress-step"><strong id="progress-current">2</strong> of 5</p>
  </div>
  <div>
    <h5 id="otp-title" class="onboarding-title">{{'verify_your_email' | translate}}</h5>
    <div id="otp-instructions">{{"enter_verification_sent_on" | translate}} <strong id="otp-email">{{ newEmail }}</strong></div>
    <p id="otp-subtitle" class="onboarding-subtitle">{{ "wrong_email_address" | translate }} <a id="change-email-link" (click)="backToRegister()" class="link">{{ "change_email_address" | translate }}</a></p>
  </div>
  <div class="eod-input m-0">
    <ng-otp-input id="ng-otp-input"
      [ngClass]="{'otp-error-state': !isValidOTPEntered && otpCode.length === 4, 'otp-valid-state': isValidOTPEntered && otpCode.length === 4}"
      [config]="otpConfig"
      (onInputChange)="onDigitInput($event)">
    </ng-otp-input>
    @if(!isValidOTPEntered && otpCode.length === 4){<small id="otp-error" class="helper-text">{{'please_enter_valid_verification_code' | translate}}</small>}
  </div>
  <ds-button
    [buttonInput]="continueConfig"
    (btnClick)="isValidOTPEntered && goToNextStep()">
  </ds-button>
  <hr class="hr-border-muted"> 
  <p id="otp-resend-section" class="text-center">{{ "didnt_receive_code" | translate }}
    @if(!canResendOTP){<span id="otp-timer" class="timer disabled">{{ "resend_code" | translate }} in {{ remainingTime }}s</span>}
    @if(canResendOTP){<a id="otp-resend-link" (click)="resendOTP()" class="link">{{ "resend_code" | translate }}</a>}
  </p>
</div>
